var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTxt = function SvgTxt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36.07",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-family:HelveticaNeue-CondensedBold, 'Helvetica Neue';font-size:12px;font-weight:700;}.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-3{fill:#231f20;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2.6,35.07c-.88,0-1.6-.72-1.6-1.6V2.67c0-.88.72-1.6,1.6-1.6h22.01l10.4,10.4v22c0,.88-.72,1.6-1.6,1.6H2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.19,2.07l9.81,9.81v21.59c0,.33-.27.6-.6.6H2.6c-.33,0-.6-.27-.6-.6V2.67c0-.33.27-.6.6-.6h21.59M25.02.07H2.6C1.16.07,0,1.23,0,2.67v30.8c0,1.43,1.16,2.6,2.6,2.6h30.8c1.43,0,2.6-1.16,2.6-2.6V11.05L25.02.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.76,8.38c0,1.43,1.16,2.6,2.6,2.6h8.38L24.76,0v8.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9,
    y: 6.59,
    width: 12.77,
    height: 3.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9,
    y: 11.5,
    width: 12.77,
    height: 3.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9,
    y: 16.41,
    width: 12.77,
    height: 3.04
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(15.63 30.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ".Txt")))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTxt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/txt.92a448e06424d27146e258222685cad8.svg";